var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.049,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.977,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3185,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.307,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.565 100.347C167.565 137.155 137.461 167.009 100.307 167.009C63.1531 167.009 33.0488 137.155 33.0488 100.347C33.0488 63.5392 63.1531 33.6855 100.307 33.6855C137.461 33.6855 167.565 63.5392 167.565 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.6144,
    cy: 69.6779,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.829,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.696,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.294,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.261,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5449,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3154,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8154,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4336,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.499,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5478,
    cy: 64.666,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3662,
    cy: 22.4228,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8828,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8095,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.436,
    cy: 18.8427,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.42 150.347 168.565 149.492 168.565 148.438C168.565 147.383 169.42 146.528 170.475 146.528",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 117.65C7.56621 117.65 8.42104 116.795 8.42104 115.74C8.42104 114.686 7.56621 113.831 6.51172 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 22.4231C75.5857 22.4231 76.4406 21.5683 76.4406 20.5138C76.4406 19.4593 75.5857 18.6045 74.5312 18.6045",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.779 15.7399 118.924 16.5948 118.924 17.6493C118.924 18.7038 119.779 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3301 166.934H16.2967M26.3207 155.836V157.387M38.0153 166.934H39.5666M26.3207 176.48V178.27M26.3207 180.657V186.982M21.9053 166.934C24.8887 166.934 26.44 162.638 26.44 162.638C26.44 162.638 26.9173 166.934 30.736 166.934C29.0176 166.934 26.5593 168.485 26.3207 171.588C26.3207 171.588 26.0428 169.048 25.1273 168.127C24.363 167.359 21.9053 166.934 21.9053 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0596L172.742 30.0596M162.599 45.8115L162.718 39.6062M151.024 30.0596L149.472 30.0596M162.599 20.7516L162.599 8.57973M167.134 30.0596C164.15 30.0596 162.599 34.3556 162.599 34.3556C162.599 34.3556 162.122 30.0596 158.303 30.0596C160.021 30.0596 162.48 28.5083 162.718 25.4056C162.718 25.4056 162.996 27.9458 163.912 28.8663C164.676 29.6348 167.134 30.0596 167.134 30.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 76.8247,
    cy: 75.3208,
    r: 47.3208,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.8244,
    cy: 75.3205,
    r: 38.9172,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2926 95.5852C70.7372 95.5852 65.5166 93.4204 61.5877 89.4975C57.6588 85.5746 55.5 80.3481 55.5 74.7926C55.5 69.2372 57.6648 64.0166 61.5877 60.0877C65.5106 56.1588 70.7372 54 76.2926 54C81.8481 54 87.0687 56.1648 90.9976 60.0877C94.9264 64.0106 97.0852 69.2372 97.0852 74.7926C97.0852 80.3481 94.9205 85.5686 90.9976 89.4975C87.0746 93.4264 81.8481 95.5852 76.2926 95.5852ZM76.2926 54.2392C70.8029 54.2392 65.6422 56.3801 61.7611 60.2611C57.8801 64.1422 55.7392 69.3029 55.7392 74.7926C55.7392 80.2823 57.8801 85.4431 61.7611 89.3241C65.6422 93.2052 70.8029 95.346 76.2926 95.346C81.7823 95.346 86.9431 93.2052 90.8241 89.3241C94.7052 85.4431 96.846 80.2823 96.846 74.7926C96.846 69.3029 94.7052 64.1422 90.8241 60.2611C86.9431 56.3801 81.7823 54.2392 76.2926 54.2392Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2924 90.1132C72.2021 90.1132 68.3569 88.5225 65.4626 85.6281C62.5682 82.7338 60.9775 78.8886 60.9775 74.7983C60.9775 70.7079 62.5682 66.8628 65.4626 63.9684C68.3569 61.0741 72.2021 59.4834 76.2924 59.4834C80.3828 59.4834 84.2279 61.0741 87.1223 63.9684C90.0166 66.8628 91.6073 70.7079 91.6073 74.7983C91.6073 78.8886 90.0166 82.7338 87.1223 85.6281C84.2279 88.5225 80.3828 90.1132 76.2924 90.1132ZM76.2924 59.7106C72.2619 59.7106 68.4765 61.2774 65.63 64.1299C62.7835 66.9764 61.2108 70.7618 61.2108 74.7923C61.2108 78.8229 62.7775 82.6082 65.63 85.4547C68.4765 88.3012 72.2619 89.874 76.2924 89.874C80.323 89.874 84.1083 88.3072 86.9548 85.4547C89.8013 82.6082 91.3741 78.8229 91.3741 74.7923C91.3741 70.7618 89.8073 66.9764 86.9548 64.1299C84.1083 61.2834 80.323 59.7106 76.2924 59.7106Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2917 80.7309C73.0146 80.7309 70.3535 78.0697 70.3535 74.7927C70.3535 71.5156 73.0146 68.8545 76.2917 68.8545C79.5688 68.8545 82.2299 71.5156 82.2299 74.7927C82.2299 78.0697 79.5688 80.7309 76.2917 80.7309ZM76.2917 69.0937C73.1522 69.0937 70.5927 71.6532 70.5927 74.7927C70.5927 77.9322 73.1522 80.4917 76.2917 80.4917C79.4312 80.4917 81.9907 77.9322 81.9907 74.7927C81.9907 71.6532 79.4312 69.0937 76.2917 69.0937Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M85.4784 78.5184C90.8222 78.5184 95.1542 74.1864 95.1542 68.8427C95.1542 63.499 90.8222 59.167 85.4784 59.167C80.1347 59.167 75.8027 63.499 75.8027 68.8427C75.8027 74.1864 80.1347 78.5184 85.4784 78.5184Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2926 95.5852C70.7372 95.5852 65.5166 93.4204 61.5877 89.4975C57.6588 85.5746 55.5 80.3481 55.5 74.7926C55.5 69.2372 57.6648 64.0166 61.5877 60.0877C65.5106 56.1588 70.7372 54 76.2926 54C81.8481 54 87.0687 56.1648 90.9976 60.0877C94.9264 64.0106 97.0852 69.2372 97.0852 74.7926C97.0852 80.3481 94.9205 85.5686 90.9976 89.4975C87.0746 93.4264 81.8481 95.5852 76.2926 95.5852ZM76.2926 54.2392C70.8029 54.2392 65.6422 56.3801 61.7611 60.2611C57.8801 64.1422 55.7392 69.3029 55.7392 74.7926C55.7392 80.2823 57.8801 85.4431 61.7611 89.3241C65.6422 93.2052 70.8029 95.346 76.2926 95.346C81.7823 95.346 86.9431 93.2052 90.8241 89.3241C94.7052 85.4431 96.846 80.2823 96.846 74.7926C96.846 69.3029 94.7052 64.1422 90.8241 60.2611C86.9431 56.3801 81.7823 54.2392 76.2926 54.2392Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.2854 76.001C58.0416 76.001 56.8396 76.1684 55.6914 76.4794C55.7871 77.6335 55.9725 78.7578 56.2476 79.8521C57.2044 79.5531 58.2269 79.3917 59.2854 79.3917C64.9186 79.3917 69.4874 83.9604 69.4874 89.5936C69.4874 91.1484 69.1405 92.6255 68.5126 93.9471C69.5591 94.3717 70.6535 94.7185 71.7777 94.9697C72.4893 93.3192 72.884 91.5072 72.884 89.5996C72.8781 82.0887 66.7904 76.001 59.2854 76.001Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4399 60.7221C89.9987 59.1733 88.3302 57.8457 86.4764 56.7992C87.6126 57.9593 88.3183 59.544 88.3183 61.2962C88.3183 64.8423 85.4479 67.7128 81.9017 67.7128C78.3555 67.7128 75.4851 64.8423 75.4851 61.2962C75.4851 57.762 78.3376 54.8975 81.8658 54.8796C80.0957 54.3832 78.224 54.1201 76.2984 54.1201C76.0592 54.1201 75.82 54.1261 75.5808 54.1321C73.6014 55.8842 72.3516 58.4437 72.3516 61.2962C72.3516 66.5766 76.6273 70.8523 81.9077 70.8523C87.1881 70.8523 91.4638 66.5766 91.4638 61.2962C91.4578 61.1048 91.4458 60.9134 91.4399 60.7221Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.976,
    y: 126.82,
    width: 21.5508,
    height: 49.407,
    rx: 4,
    transform: "rotate(-44.8121 112.976 126.82)",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.537 112.437L116.742 123.641",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.94 104.033L125.145 115.238",
    stroke: "#787E8C",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.9e8d3f3af3065a89082612b80124172c.svg";
export { ForwardRef as ReactComponent };